import React from "react";
import loadable from "@loadable/component";

const Canonical = process.env.NODE_ENV === "production" ? null : loadable(() => import("./Canonical"), { ssr: false });
const Nav = process.env.NODE_ENV === "production" ? null : loadable(() => import("./Nav"), { ssr: false });

const DevNav: React.FC =
  process.env.NODE_ENV === "production"
    ? () => null
    : () => {
        if (typeof window === "undefined" || !Canonical || !Nav) return null;
        return (
          <>
            <Canonical />
            <Nav />
          </>
        );
      };

export default DevNav;
